/**
 * Size option prices for the theme Variant picker (VO-style layout).
 * Also keeps legacy #bcpo support if VO is still rendered somewhere.
 */
(function () {
  var LOCALE_BY_CURRENCY = {
    USD: 'en-US',
    CAD: 'en-CA',
    AUD: 'en-AU',
    NZD: 'en-NZ',
    GBP: 'en-GB',
    EUR: 'de-DE',
    CHF: 'de-CH',
    JPY: 'ja-JP',
    CNY: 'zh-CN',
    HKD: 'zh-HK',
    SGD: 'en-SG',
    THB: 'th-TH',
    MKD: 'mk-MK',
    MXN: 'es-MX',
    BRL: 'pt-BR',
    INR: 'en-IN',
    KRW: 'ko-KR',
    SEK: 'sv-SE',
    NOK: 'nb-NO',
    DKK: 'da-DK',
    PLN: 'pl-PL',
    CZK: 'cs-CZ',
    HUF: 'hu-HU',
    RON: 'ro-RO',
    BGN: 'bg-BG',
    ILS: 'he-IL',
    AED: 'ar-AE',
    SAR: 'ar-SA',
    ZAR: 'en-ZA',
    IDR: 'en-US'
  };

  var CURRENCY_SYMBOL_WHEN_INTL_SHOWS_CODE = {
    MKD: 'ден',
    THB: '฿'
  };

  var CURRENCY_LABEL_OVERRIDE = {
    IDR: 'IDR'
  };

  var productCache = null;
  var scheduleTimer = null;

  function normalizeCurrencyCode(currencyCode) {
    if (currencyCode == null || currencyCode === '') return 'USD';
    return String(currencyCode).trim().toUpperCase();
  }

  function localeForCurrencyFormatting(normalizedCode) {
    if (LOCALE_BY_CURRENCY[normalizedCode]) {
      return LOCALE_BY_CURRENCY[normalizedCode];
    }
    var pageLang = (document.documentElement.lang || '').trim();
    if (/^[a-z]{2}-[A-Z]{2}$/i.test(pageLang)) {
      return pageLang;
    }
    return 'en-US';
  }

  function formatPresentmentMoney(minorAmount, currencyCode) {
    try {
      var code = normalizeCurrencyCode(currencyCode);
      var locale = localeForCurrencyFormatting(code);
      var nf = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      var amount = Number(minorAmount) / 100;
      var parts = nf.formatToParts(amount);
      var sym = CURRENCY_SYMBOL_WHEN_INTL_SHOWS_CODE[code];
      var label = CURRENCY_LABEL_OVERRIDE[code];
      var i;
      for (i = 0; i < parts.length; i++) {
        if (parts[i].type !== 'currency') continue;
        if (label) {
          parts[i] = { type: 'currency', value: label };
          break;
        }
        if (sym && parts[i].value.replace(/\s/g, '') === code) {
          parts[i] = { type: 'currency', value: sym };
          break;
        }
      }
      var formatted = parts
        .map(function (p) {
          return p.value;
        })
        .join('');
      return formatted.replace(/\.00$/, '');
    } catch (e) {
      return (Number(minorAmount) / 100).toFixed(2);
    }
  }

  function getActiveCurrencyCode() {
    var sc = window.Shopify && window.Shopify.currency;
    return normalizeCurrencyCode((sc && (sc.active || sc.iso_code)) || 'USD');
  }

  function getVisibleProductPriceText() {
    var priceElements = document.querySelectorAll('[data-product-price]');
    for (var i = 0; i < priceElements.length; i++) {
      var el = priceElements[i];
      if (el && el.offsetParent !== null) {
        var txt = (el.textContent || '').trim().replace(/\.00$/, '');
        if (txt) return txt;
      }
    }
    return null;
  }

  function getVisibleCompareAtPriceText() {
    var strikeEls = document.querySelectorAll(
      's .money, .product__price--strike .money, s[data-compare-price], [data-compare-price]'
    );
    for (var i = 0; i < strikeEls.length; i++) {
      var el = strikeEls[i];
      if (el && el.offsetParent !== null) {
        var txt = (el.textContent || '').trim().replace(/\.00$/, '');
        if (txt) return txt;
      }
    }
    return null;
  }

  function getOptionIndexByName(product, needle) {
    if (!product || !product.options || !needle) return -1;
    var name = String(needle).toLowerCase();
    for (var i = 0; i < product.options.length; i++) {
      var opt = product.options[i];
      var optName = typeof opt === 'string' ? opt : opt && opt.name;
      if (optName && String(optName).toLowerCase().indexOf(name) !== -1) {
        return i;
      }
    }
    return -1;
  }

  function getSizeOptionIndex(product) {
    return getOptionIndexByName(product, 'size');
  }

  function getAddonAmount(product, optionIndex, selectedByPosition) {
    if (!product || !product.variants || optionIndex < 0) return null;

    var optionPos = optionIndex + 1;
    var selectedValue = selectedByPosition[optionPos];
    if (!selectedValue) return null;

    var minPrice = Infinity;
    var selectedPrice = null;
    var i;
    var v;
    var pos;
    var matchesOthers;
    var variantOption;

    for (i = 0; i < product.variants.length; i++) {
      v = product.variants[i];
      matchesOthers = true;
      for (pos in selectedByPosition) {
        if (!Object.prototype.hasOwnProperty.call(selectedByPosition, pos)) continue;
        if (parseInt(pos, 10) === optionPos) continue;
        variantOption = v['option' + pos] || (v.options && v.options[parseInt(pos, 10) - 1]);
        if (variantOption !== selectedByPosition[pos]) {
          matchesOthers = false;
          break;
        }
      }
      if (!matchesOthers) continue;
      if (v.price < minPrice) minPrice = v.price;
      variantOption = v['option' + optionPos] || (v.options && v.options[optionIndex]);
      if (variantOption === selectedValue) selectedPrice = v.price;
    }

    if (selectedPrice == null || minPrice === Infinity) return null;
    var delta = selectedPrice - minPrice;
    return delta > 0 ? delta : 0;
  }

  function getSelectedOptionsFromDom(root) {
    var selected = {};
    var fields = (root || document).querySelectorAll('variant-selects fieldset.product-form__input[data-option-position]');
    for (var i = 0; i < fields.length; i++) {
      var fs = fields[i];
      var pos = parseInt(fs.getAttribute('data-option-position'), 10);
      if (!pos) continue;
      var checked = fs.querySelector('input[type="radio"]:checked, select option:checked');
      if (checked && checked.value) {
        selected[pos] = checked.value;
      }
    }
    return selected;
  }

  function findVariantForSize(product, sizeText, selectedByPosition, sizeOptionIndex) {
    if (!product || !product.variants || !sizeText) return null;

    var sizePos = sizeOptionIndex + 1;
    var exact = product.variants.find(function (v) {
      var sizeVal = v['option' + sizePos] || (v.options && v.options[sizeOptionIndex]);
      if (sizeVal !== sizeText) return false;
      for (var pos in selectedByPosition) {
        if (!Object.prototype.hasOwnProperty.call(selectedByPosition, pos)) continue;
        if (parseInt(pos, 10) === sizePos) continue;
        if (v['option' + pos] !== selectedByPosition[pos]) return false;
      }
      return true;
    });
    if (exact) return exact;

    return product.variants.find(function (v) {
      return Array.isArray(v.options) && v.options.indexOf(sizeText) !== -1;
    }) || null;
  }

  function setPriceHtml(priceSpan, variant, currency, options) {
    if (!priceSpan || !variant) return;
    options = options || {};
    var useVisibleCurrent = options.useVisibleCurrent === true;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var currentPriceText = useVisibleCurrent ? getVisibleProductPriceText() : null;

    if (onSale) {
      var strikeText = formatPresentmentMoney(variant.compare_at_price, currency);
      var currentText = currentPriceText || formatPresentmentMoney(variant.price, currency);
      var expected = (strikeText + ' ' + currentText).replace(/\s+/g, ' ').trim();
      if ((priceSpan.textContent || '').replace(/\s+/g, ' ').trim() === expected) return;
      priceSpan.innerHTML = '';
      var strike = document.createElement('s');
      strike.className = 'product__price--strike';
      strike.textContent = strikeText;
      priceSpan.appendChild(strike);
      priceSpan.appendChild(document.createTextNode(' '));
      var current = document.createElement('span');
      current.className = 'size-priced-option__current-price';
      current.textContent = currentText;
      priceSpan.appendChild(current);
    } else {
      var regularText = currentPriceText || formatPresentmentMoney(variant.price, currency);
      if ((priceSpan.textContent || '').replace(/\s+/g, ' ').trim() === regularText) return;
      priceSpan.innerHTML = '';
      var regular = document.createElement('span');
      regular.className = 'size-priced-option__current-price';
      regular.textContent = regularText;
      priceSpan.appendChild(regular);
    }
  }

  function updateNativeSizePrices(product) {
    if (!product || !product.variants) return;

    var sizeOptionIndex = getSizeOptionIndex(product);
    if (sizeOptionIndex < 0) return;

    var currency = getActiveCurrencyCode();
    var roots = document.querySelectorAll('variant-selects');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var selected = getSelectedOptionsFromDom(root);
      var labels = root.querySelectorAll('.product-form__input--size-priced label.size-priced-option');

      labels.forEach(function (label) {
        var optionText = (label.getAttribute('data-option-text') || '').trim();
        if (!optionText) {
          var textEl = label.querySelector('.size-priced-option__text');
          optionText = textEl ? textEl.textContent.trim() : '';
        }
        if (!optionText) return;

        var priceSpan = label.querySelector('[data-size-price], .vo-price-display');
        if (!priceSpan) return;

        var variant = findVariantForSize(product, optionText, selected, sizeOptionIndex);
        if (!variant) return;

        setPriceHtml(priceSpan, variant, currency);
      });
    });
  }

  function updateLegacyVoPrices(product) {
    if (!product || !product.variants) return;
    if (!document.querySelector('#bcpo .bcpo-front-button-label')) return;

    var currency = getActiveCurrencyCode();
    var labels = document.querySelectorAll('#bcpo .bcpo-front-button-label');

    labels.forEach(function (label) {
      var optionText =
        (label.getAttribute('data-vo-option-text') || '').trim() ||
        (label.querySelector('span') ? label.querySelector('span').textContent.trim() : label.textContent.trim());

      if (!optionText) return;
      label.setAttribute('data-vo-option-text', optionText);

      var variant = product.variants.find(function (v) {
        return Array.isArray(v.options) && v.options.indexOf(optionText) !== -1;
      });
      if (!variant) return;

      var wrapper = label.querySelector('[data-vo-wrapper="1"]');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.setAttribute('data-vo-wrapper', '1');
        wrapper.style.display = 'flex';
        wrapper.style.justifyContent = 'space-between';
        wrapper.style.width = '100%';

        var textSpan = document.createElement('span');
        textSpan.textContent = optionText;

        var priceSpan = document.createElement('span');
        priceSpan.className = 'vo-price-display custom-price';

        label.innerHTML = '';
        wrapper.appendChild(textSpan);
        wrapper.appendChild(priceSpan);
        label.appendChild(wrapper);
      }

      var priceEl = label.querySelector('.vo-price-display');
      if (!priceEl) return;

      setPriceHtml(priceEl, variant, currency);
    });
  }

  function ensureAddonElement(field) {
    var addonEl = field.querySelector('[data-option-addon]');
    if (addonEl) return addonEl;

    var selectedEl =
      field.querySelector('[data-selected-value]') ||
      field.querySelector('[data-selected-swatch-value]');
    if (!selectedEl) return null;

    addonEl = document.createElement('span');
    addonEl.className = 'option-addon-price';
    addonEl.setAttribute('data-option-addon', '');
    selectedEl.parentNode.insertBefore(addonEl, selectedEl.nextSibling);
    return addonEl;
  }

  function updateBaseAddonPrices(product) {
    if (!product || !product.variants) return;

    var baseOptionIndex = getOptionIndexByName(product, 'base');
    if (baseOptionIndex < 0) return;

    var currency = getActiveCurrencyCode();
    var roots = document.querySelectorAll('variant-selects');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var selected = getSelectedOptionsFromDom(root);
      var addonAmount = getAddonAmount(product, baseOptionIndex, selected);
      var fields = root.querySelectorAll('[data-base-addon="true"], [data-option-name="Base"]');
      if (!fields.length) {
        fields = root.querySelectorAll('[data-option-name]');
        fields = Array.prototype.filter.call(fields, function (field) {
          return String(field.getAttribute('data-option-name') || '')
            .toLowerCase()
            .indexOf('base') !== -1;
        });
      }

      Array.prototype.forEach.call(fields, function (field) {
        var addonEl = ensureAddonElement(field);
        if (!addonEl) return;
        if (addonAmount == null) return;
        var nextText = addonAmount > 0 ? ' (+' + formatPresentmentMoney(addonAmount, currency) + ')' : '';
        if (addonEl.textContent === nextText) return;
        addonEl.textContent = nextText;
      });
    });
  }

  function updateAllPrices(product) {
    updateNativeSizePrices(product);
    updateBaseAddonPrices(product);
    updateLegacyVoPrices(product);
  }

  function scheduleUpdate(product) {
    if (scheduleTimer) clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(function () {
      updateAllPrices(product || productCache);
    }, 0);
  }

  function bindListeners(product) {
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (t.closest && (t.closest('variant-selects') || t.closest('#bcpo'))) {
          scheduleUpdate(product);
        }
      },
      true
    );

    document.addEventListener('variant:changed', function () {
      scheduleUpdate(product);
    });

    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      try {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
          scheduleUpdate(product);
        });
      } catch (err) {}
    }
  }

  function init() {
    if (window.location.pathname.indexOf('/products/') === -1) return;

    fetch(window.location.pathname + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        productCache = product;
        updateAllPrices(product);
        bindListeners(product);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 300);
    });
  } else {
    setTimeout(init, 300);
  }
})();
